import _ from 'lodash';
import * as React from 'react';
import { Container } from 'types/Watchlist';
import {
  formatDemurrage,
  formatGTD,
  formatLastFreeDay,
  formatOriginalLastFreeDay,
} from 'utils/container-transforms';
import { Row, RowGroup } from '../components';

interface Props {
  container: Container;
}

export const Demurrage: React.FC<Props> = (props) => {
  const { container } = props;

  const demurrage = formatDemurrage(container);
  const lastFreeDay = formatLastFreeDay(container);
  const goodThroughDate = formatGTD(container);
  const originalLastFreeDay = formatOriginalLastFreeDay(container);

  let demurrageDueText = null;
  if (!_.isNil(demurrage?.meta?.demurrageDue)) {
    demurrageDueText = demurrage?.meta?.demurrageDue ? 'Yes' : 'No';
  }

  return (
    <RowGroup label="Demurrage">
      <Row label="(NEW) Good Through Date">{goodThroughDate?.value}</Row>
      <Row label="(NEW) Last Free Day">{lastFreeDay?.value}</Row>
      <Row label="(INITIAL) Last Free Day">{originalLastFreeDay?.value}</Row>
      <Row label="Demurrage Due">{demurrageDueText}</Row>
      <Row label="Demurrage Amount">{demurrage?.value}</Row>
    </RowGroup>
  );
};
Demurrage.displayName = 'Shipments.DetailDrawer.Sections.Availability.Demurrage';
